<label {id} class="prom-switch {cssClass}">
    <input
        type="checkbox"
        class="prom-switch__input | screen-reader"
        {disabled}
        name="{nameText}"
        value="{value}"
        bind:checked
        on:click={handleClick}
    />
    <span class="prom-switch__custom-button">
        <span class="prom-switch__custom-button-inner"></span>
    </span>
    <span class="prom-switch__label-text">
        {labelText}
    </span>
</label>

<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /** @type {boolean} */
    export let checked = false;

    /** @type {boolean} */
    export let disabled = false;

    /** @type {string} */
    export let id = '';

    /** @type {string} */
    export let label = undefined;

    /** @type {string} */
    export let name = undefined;

    /** @type {string} */
    export let value = undefined;

    let cssClass

    $ : {
        cssClass = disabled ? 'disabled' : '';
    }

    let labelText;

    $: {
        if (!label || typeof label !== 'string') {
            throw new TypeError('Label must be supplied');
        }

        labelText = label;
    }

    let nameText;

    $: {
        if (!name || typeof name !== 'string') {
            throw new TypeError('Name must be supplied');
        }

        nameText = name;
    }

    function handleClick() {
        dispatch('click', { checked });
    }
</script>
